<template>
    <el-dialog
        id="accept-tcs-modal"
        title="Terms and Conditions Update"
        data-test="accepts-tcs-modal"
        custom-class="accept-tcs-modal"
        :visible="isVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        append-to-body
    >
        <p class="accept-tcs-modal__heading">
            A change in our Terms and Conditions was made. To continue using the platform, please read and accept the T&Cs.
        </p>
        <p>
            View the new
            <a
                :href="value.new_url"
                class="link"
                target="_blank"
            >
                <i class="el-icon-document" />
                Terms and Conditions
            </a>
        </p>
        <div class="accept-tcs-modal__fields">
            <form-field
                v-for="field in fields"
                :key="field.name"
                v-model="models[field.name]"
                :class="`accept-tcs-modal--${field.name}`"
                :field="field"
            />
        </div>
        <div slot="footer">
            <ui-button
                :disabled="isBusy"
                variant="secondary"
                content="Decline"
                @click="logout"
            />
            <ui-button
                :disabled="isAcceptBtnDisabled || isBusy"
                content="Accept"
                @click="acceptTCs"
            />
        </div>
    </el-dialog>
</template>

<script>
import FormField from 'shared-lib/components/forms/FormField';
import UiButton from 'shared-lib/components/ui/UiButton';
import { logout as authLogout } from '@/store/auth';
import router from '@/router';
import api from '@/api';
import { getCurrentUser } from '@/store/user';

export default {
    name: 'AcceptTCsModal',

    components: {
        FormField,
        UiButton,
    },

    inject: [ '$validator' ],

    props: {
        value: {
            type: Object,
            default: null,
        },
    },

    data () {
        return {
            isBusy: false,
            models: {},
        };
    },

    computed: {
        isVisible () {
            return !!this.value;
        },
        isAcceptBtnDisabled () {
            return false;
        },
        fields () {
            return [
                {
                    name: 'tos',
                    type: 'checkbox',
                    options: [{
                        value: 1,
                        uncheckedValue: '',
                        text: 'I accept the new Terms and Conditions.',
                    }],
                    validate: 'required',
                },
            ];
        },
    },

    methods: {
        logout () {
            authLogout()
                .then(() => router.push({ name: 'Login' }));
        },

        acceptTCs () {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return false;
                }

                this.isBusy = true;

                api.profile.acceptTCs(this.models)
                    .then(() => getCurrentUser())
                    .catch(() => this.isBusy = false)
                ;
            });
        },
    },
};
</script>

<style lang="scss">
    .accept-tcs-modal__heading {
        margin-bottom: 1em;
    }

    .accept-tcs-modal__fields {
        margin-top: 1.25em;
    }

    .accept-tcs-modal--tos {
        font-weight: bold;
    }

    #accept-tcs-modal {
        .accept-tcs-modal {
            border-radius: 20px;
        }
    }
</style>
